var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.blockType === _vm.BT.BOT_RESPONSE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.BOT_RESPONSE },
        },
        [_vm._v(" send ")]
      )
    : _vm.blockType === _vm.BT.START_POINT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.START_POINT },
        },
        [_vm._v(" home ")]
      )
    : _vm.blockType === _vm.BT.ATTACHMENT_INPUT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.ATTACHMENT_INPUT },
        },
        [_vm._v("\n    attachment\n")]
      )
    : _vm.blockType === _vm.BT.FILTER
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.FILTER },
        },
        [_vm._v(" filter_alt ")]
      )
    : _vm.blockType === _vm.BT.USER_INPUT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.USER_INPUT },
        },
        [_vm._v("\n    record_voice_over\n")]
      )
    : _vm.blockType === _vm.BT.GO_TO_STEP
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.GO_TO_STEP },
        },
        [_vm._v(" cable ")]
      )
    : _vm.blockType === _vm.BT.ADD_TO_SEGMENT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.ADD_TO_SEGMENT },
        },
        [_vm._v("\n    pie_chart\n")]
      )
    : _vm.blockType === _vm.BT.REMOVE_FROM_SEGMENT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.REMOVE_FROM_SEGMENT },
        },
        [_vm._v("\n    pie_chart\n")]
      )
    : _vm.blockType === _vm.BT.DEFAULT_FALLBACK
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.DEFAULT_FALLBACK },
        },
        [_vm._v("\n    heart_broken\n")]
      )
    : _vm.blockType === _vm.BT.FALLBACK
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.FALLBACK },
        },
        [_vm._v(" heart_broken ")]
      )
    : _vm.blockType === _vm.BT.QUESTION
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.QUESTION },
        },
        [_vm._v(" quiz ")]
      )
    : _vm.blockType === _vm.BT.SET_ATTRIBUTE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.SET_ATTRIBUTE },
        },
        [_vm._v("\n    data_object\n")]
      )
    : _vm.blockType === _vm.BT.CLOSE_CHAT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.CLOSE_CHAT },
        },
        [_vm._v("\n    mark_chat_read\n")]
      )
    : _vm.blockType === _vm.BT.SUCCESS
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.SUCCESS },
        },
        [_vm._v(" check_circle ")]
      )
    : _vm.blockType === _vm.BT.FAILURE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.FAILURE },
        },
        [_vm._v(" cancel ")]
      )
    : _vm.blockType === _vm.BT.FLOW
    ? _c(
        "span",
        { staticClass: "material-icons", attrs: { "data-type": _vm.BT.FLOW } },
        [_vm._v("schema")]
      )
    : _vm.blockType === _vm.BT.PLATFORM_FLOW
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.PLATFORM_FLOW },
        },
        [_vm._v("schema")]
      )
    : _vm.blockType === _vm.BT.CREATE_TICKET
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.CREATE_TICKET },
        },
        [_vm._v("\n    local_activity\n")]
      )
    : _vm.blockType === _vm.BT.TAG_CHAT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.TAG_CHAT },
        },
        [_vm._v(" bookmark ")]
      )
    : _vm.blockType === _vm.BT.REMOVE_TAG
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.REMOVE_TAG },
        },
        [_vm._v("\n    bookmark_remove\n")]
      )
    : _vm.blockType === _vm.BT.TRANSFER_CHAT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.TRANSFER_CHAT },
        },
        [_vm._v("\n    support_agent\n")]
      )
    : _vm.blockType === _vm.BT.TRANSFER_TO_CHATBOT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.TRANSFER_TO_CHATBOT },
        },
        [_vm._v("\n    fast_forward\n")]
      )
    : _vm.blockType === _vm.BT.SEND_TRANSCRIPT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.SEND_TRANSCRIPT },
        },
        [_vm._v("\n    attach_email\n")]
      )
    : _vm.blockType === _vm.BT.SEND_SMS
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.SEND_SMS },
        },
        [_vm._v(" sms ")]
      )
    : _vm.blockType === _vm.BT.SEND_MAIL
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.SEND_MAIL },
        },
        [_vm._v(" mail ")]
      )
    : _vm.blockType === _vm.BT.CREATE_EVENT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.CREATE_EVENT },
        },
        [_vm._v(" event ")]
      )
    : _vm.blockType === _vm.BT.CREATE_RESERVATION
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.CREATE_RESERVATION },
        },
        [_vm._v("\n    calendar_month\n")]
      )
    : _vm.blockType === _vm.BT.RESERVATION_OPEN_URL
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.RESERVATION_OPEN_URL },
        },
        [_vm._v("\n    event\n")]
      )
    : _vm.blockType === _vm.BT.RESERVATION_SELECT_DAY
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.RESERVATION_SELECT_DAY },
        },
        [_vm._v("\n    calendar_month\n")]
      )
    : _vm.blockType === _vm.BT.RESERVATION_EVENT_LIST
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.RESERVATION_EVENT_LIST },
        },
        [_vm._v("\n    event_note\n")]
      )
    : _vm.blockType === _vm.BT.RESERVATION_SELECT_TIME
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.RESERVATION_SELECT_TIME },
        },
        [_vm._v("\n    calendar_month\n")]
      )
    : _vm.blockType === _vm.BT.WEBHOOK
    ? _c(
        "span",
        {
          staticClass: "material-icons text-light",
          attrs: { "data-type": _vm.BT.WEBHOOK },
        },
        [_vm._v("\n    webhook\n")]
      )
    : _vm.blockType === _vm.BT.GET_LOCATION
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.GET_LOCATION },
        },
        [_vm._v("\n    location_on\n")]
      )
    : _vm.blockType === _vm.BT.SET_DEPARTMENT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.SET_DEPARTMENT },
        },
        [_vm._v("\n    category\n")]
      )
    : _vm.blockType === _vm.BT.AI_BOT_RESPONSE
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: {
          src: "/static/img/openai.png",
          "data-type": _vm.BT.AI_BOT_RESPONSE,
        },
      })
    : _vm.blockType === _vm.BT.AI_ASSISTANT
    ? _c(
        "div",
        {
          staticClass: "custom-block-logo ai-assistant",
          attrs: { "data-type": _vm.BT.AI_ASSISTANT },
        },
        [_c("OpenaiIcon")],
        1
      )
    : _vm.blockType === _vm.BT.CREATE_TASK
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.CREATE_TASK },
        },
        [_vm._v(" add_task ")]
      )
    : _vm.blockType === _vm.BT.SUPPRESSION_ADD
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.SUPPRESSION_ADD },
        },
        [_vm._v("\n    block\n")]
      )
    : _vm.blockType === _vm.BT.SUPPRESSION_REMOVE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.SUPPRESSION_REMOVE },
        },
        [_vm._v("\n    lock_open\n")]
      )
    : _vm.blockType === _vm.BT.DEFAULT_TIMEOUT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.DEFAULT_TIMEOUT },
        },
        [_vm._v("\n    timer\n")]
      )
    : _vm.blockType === _vm.BT.TIMEOUT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.TIMEOUT },
        },
        [_vm._v(" timer ")]
      )
    : _vm.blockType === _vm.BT.SEND_WP_BUSINESS_MESSAGE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.SEND_WP_BUSINESS_MESSAGE },
        },
        [_vm._v("\n    send\n")]
      )
    : _vm.blockType === _vm.BT.INSTAGRAM_COMMENT_REPLY
    ? _c("InstagramIcon", {
        staticClass: "custom-block-logo",
        attrs: { "data-type": _vm.BT.INSTAGRAM_COMMENT_REPLY },
      })
    : _vm.blockType === _vm.BT.INSTAGRAM_COMMENT_DELETE
    ? _c("InstagramIcon", {
        staticClass: "custom-block-logo",
        attrs: { "data-type": _vm.BT.INSTAGRAM_COMMENT_DELETE },
      })
    : _vm.blockType === _vm.BT.INSTAGRAM_COMMENT_SHOW
    ? _c("InstagramIcon", {
        staticClass: "custom-block-logo",
        attrs: { "data-type": _vm.BT.INSTAGRAM_COMMENT_SHOW },
      })
    : _vm.blockType === _vm.BT.INSTAGRAM_COMMENT_HIDE
    ? _c("InstagramIcon", {
        staticClass: "custom-block-logo",
        attrs: { "data-type": _vm.BT.INSTAGRAM_COMMENT_HIDE },
      })
    : _vm.blockType === _vm.BT.AI_INSTAGRAM_FLOW
    ? _c("InstagramIcon", {
        staticClass: "custom-block-logo",
        attrs: { "data-type": _vm.BT.AI_INSTAGRAM_FLOW },
      })
    : _vm.blockType === _vm.BT.INSTAGRAM_COMMENT_REPLY_AS_PRIVATE
    ? _c("InstagramIcon", {
        staticClass: "custom-block-logo",
        attrs: { "data-type": _vm.BT.INSTAGRAM_COMMENT_REPLY_AS_PRIVATE },
      })
    : _vm.blockType === _vm.BT.AI_MENU_FLOW
    ? _c("AIClassificationIcon", {
        staticClass: "custom-block-logo",
        attrs: { "data-type": _vm.BT.AI_MENU_FLOW },
      })
    : _vm.blockType === _vm.BT.AI_CLASSIFICATION
    ? _c("AIClassificationIcon", {
        staticClass: "custom-block-logo",
        attrs: { "data-type": _vm.BT.AI_CLASSIFICATION },
      })
    : _vm.blockType === _vm.BT.OTP_WHATSAPP_FLOW
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.OTP_WHATSAPP_FLOW },
        },
        [_vm._v("\n    sms\n")]
      )
    : _vm.blockType === _vm.BT.OTP_SMS_FLOW
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.OTP_SMS_FLOW },
        },
        [_vm._v(" sms ")]
      )
    : _vm.blockType === _vm.BT.OTP_MAIL_FLOW
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.OTP_MAIL_FLOW },
        },
        [_vm._v(" mail ")]
      )
    : _vm.blockType === _vm.BT.SLEEP
    ? _c(
        "span",
        { staticClass: "material-icons", attrs: { "data-type": _vm.BT.SLEEP } },
        [_vm._v(" bedtime ")]
      )
    : _vm.blockType === _vm.BT.NOOP
    ? _c(
        "span",
        { staticClass: "material-icons", attrs: { "data-type": _vm.BT.NOOP } },
        [_vm._v(" handshake ")]
      )
    : _vm.blockType === _vm.BT.WEBHOOK
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.WEBHOOK },
        },
        [_vm._v(" webhook ")]
      )
    : _vm.blockType === _vm.BT.LOOP
    ? _c(
        "span",
        { staticClass: "material-icons", attrs: { "data-type": _vm.BT.LOOP } },
        [_vm._v(" loop ")]
      )
    : _vm.blockType === _vm.BT.LOOP_NEXT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.LOOP_NEXT },
        },
        [_vm._v(" next_plan ")]
      )
    : _vm.blockType === _vm.BT.LOOP_BREAK
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.LOOP_BREAK },
        },
        [_vm._v("\n    keyboard_return\n")]
      )
    : _vm.blockType === _vm.BT.LOOP_CONTINUE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.LOOP_CONTINUE },
        },
        [_vm._v("\n    next_plan\n")]
      )
    : _vm.blockType === _vm.BT.LOOP_FINISH
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.LOOP_FINISH },
        },
        [_vm._v("\n    check_circle\n")]
      )
    : _vm.blockType === _vm.BT.FIND_CONTACTS
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.FIND_CONTACTS },
        },
        [_vm._v("\n    person_search\n")]
      )
    : _vm.blockType === _vm.BT.FIND_CONTACT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.FIND_CONTACTS },
        },
        [_vm._v("\n    person_search\n")]
      )
    : _vm.blockType === _vm.BT.TERMINATE_AUTOMATION
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.TERMINATE_AUTOMATION },
        },
        [_vm._v("\n    waving_hand\n")]
      )
    : _vm.blockType === _vm.BT.FIND_CHATS
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.FIND_CHATS },
        },
        [_vm._v(" quickreply ")]
      )
    : _vm.blockType === _vm.BT.FIND_CHAT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.FIND_CHAT },
        },
        [_vm._v(" quickreply ")]
      )
    : _vm.blockType === _vm.BT.STRING_FORMAT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.STRING_FORMAT },
        },
        [_vm._v("\n    text_fields\n")]
      )
    : _vm.blockType === _vm.BT.NUMBER_FORMAT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.NUMBER_FORMAT },
        },
        [_vm._v("\n    calculate\n")]
      )
    : _vm.blockType === _vm.BT.DATE_FORMAT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.DATE_FORMAT },
        },
        [_vm._v("\n    calendar_month\n")]
      )
    : _vm.blockType === _vm.BT.WAIT_FOR
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.WAIT_FOR },
        },
        [_vm._v(" hourglass_top ")]
      )
    : _vm.blockType === _vm.BT.CREATE_CONTACT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.CREATE_CONTACT },
        },
        [_vm._v("\n    person_add\n")]
      )
    : _vm.blockType === _vm.BT.CATCH_WEBHOOK
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.CATCH_WEBHOOK },
        },
        [_vm._v("\n    webhook\n")]
      )
    : _vm.blockType === _vm.BT.RECORDS_FROM_CSV
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BT.RECORDS_FROM_CSV },
        },
        [_vm._v("\n    upload_file\n")]
      )
    : _c("span", { staticClass: "material-icons" }, [_vm._v(" offline_bolt ")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }